import {
    INCREMENT_COUNTER,
    DECREMENT_COUNTER,
    QUESTION_INPUT,
    CREATE_DOCUMENT
} from "./testConstants";
import { createReducer } from "../../util/reducerUtil";

const initialState = {
    data: 43,
    questions: []
};

export const incrementCounter = (state, payload) => {
    return { ...state, data: state.data + 1 };
};

export const decrementCounter = (state, payload) => {
    return { ...state, data: state.data - 1 };
};

export const qustionInput = (state, payload) => {
    return { ...state, data: state.questions.push(payload.question) };
    // return [...state, Object.assign({}, payload.question)];
};

export const createNewDocument = (state, payload) => {
    return { ...state, payload };
};

// const testReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case INCREMENT_COUNTER:
//       return { ...state, data: state.data + 1 };
//     case DECREMENT_COUNTER:
//       return { ...state, data: state.data - 1 };
//     default:
//       return state;
//   }
// };

export default createReducer(initialState, {
    [INCREMENT_COUNTER]: incrementCounter,
    [DECREMENT_COUNTER]: decrementCounter,
    [QUESTION_INPUT]: qustionInput,
    [CREATE_DOCUMENT]: createNewDocument
});
